import type { Folder } from '../../../../types';

type RawSubFolder = {
  id?: string;
  name?: string;
  createdAt?: string;
  updatedAt?: string;
  isHidden?: boolean;
  hidden?: boolean;
  createdBy?: unknown;
};

type RawRootFolder = {
  subFolders?: RawSubFolder[] | null;
};

type ArchiveLike = {
  rootFolder?: RawRootFolder | null;
};

export function flattenFoldersFromArchive(
  archive: ArchiveLike | null | undefined,
  archiveId?: string
): Folder[] {
  const rf = archive?.rootFolder;
  const subs: RawSubFolder[] = Array.isArray(rf?.subFolders) ? (rf.subFolders ?? []) : [];

  return subs.map((sf) => ({
    id: String(sf.id ?? ''),
    name: String(sf.name ?? ''),
    createdAt: String(sf.createdAt ?? ''),
    updatedAt: String(sf.updatedAt ?? ''),
    hidden: Boolean(sf.isHidden ?? sf.hidden ?? false),
    createdBy: (sf.createdBy as unknown) ?? null,
    archiveId: String(archiveId ?? ''),
  }));
}
